import * as React from 'react';
import { SVGProps } from 'react';

const IconMoleculesSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 3c0 .58-.247 1.103-.642 1.468l1.912 3.55a1.5 1.5 0 1 1-.88.474l-1.912-3.55a2.005 2.005 0 0 1-.956 0L3.61 8.492a1.5 1.5 0 1 1-.88-.474l1.91-3.55A2 2 0 1 1 8 3z" />
  </svg>
);
export default IconMoleculesSizeXs;
